import React from 'react'

import Box from '@material-ui/core/Box'

export default () => (
  <Box
    display="flex"
    justifyContent="center"
    alignItems="center"
    minHeight={461}
  >
    <span>Loading...</span>
  </Box>
)



// WEBPACK FOOTER //
// ./src/Containers/StatsOverview/components/HighchartsCharts/components/Loader.js